import React, { Component } from "react";
import Swiper from "react-slick";
import SliderNavigationButton from "ReactComponents/Shared/SliderNavigation/slider-navigation-button";

class ProductReviewBlock extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        const reviewsArray = this.props.productReviews;
        const reviewsCount = reviewsArray.length;
        const swiperSettings = {
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: reviewsCount > 1,
            arrows: true,
            prevArrow: <SliderNavigationButton arrowDirection="left" />,
            nextArrow: <SliderNavigationButton arrowDirection="right" />,
            easing: "ease",
            speed: "400"
        };

        return (
            <div className="product-review-block">
                <div className="product-review-block__slider custom-slick-slider">
                    <Swiper {...swiperSettings}>
                        {reviewsArray &&
                            reviewsArray.map((review, index) => {
                                return (
                                    <div key={index}>
                                        <div className="product-review__item">
                                            <div
                                                className="product-review__item__body"
                                                dangerouslySetInnerHTML={{ __html: review.ReviewText }}
                                            />
                                            {review.ReviewAuthor && (
                                                <div
                                                    className="product-review__item__author"
                                                    dangerouslySetInnerHTML={{ __html: review.ReviewAuthor }}
                                                />
                                            )}
                                            {(review.ReviewSource || review.ReviewDate) && (
                                                <div className="product-review__item__origin">
                                                    {review.ReviewSource && (
                                                        <span
                                                            className="origin-source"
                                                            dangerouslySetInnerHTML={{
                                                                __html: review.ReviewSource
                                                            }}
                                                        />
                                                    )}
                                                    {review.ReviewDate && (
                                                        <span
                                                            className="origin-date"
                                                            dangerouslySetInnerHTML={{
                                                                __html: review.ReviewDate
                                                            }}
                                                        />
                                                    )}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                );
                            })}
                    </Swiper>
                </div>
            </div>
        );
    }
}

export default ProductReviewBlock;
